import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=9b98d7c8&scoped=true"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=9b98d7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b98d7c8",
  null
  
)

export default component.exports